module.exports = {"meta":{"description":"Add a \"Cards\" subtab under Team tabs on Home","link":"https://trello.com/c/tP7dwvkn/312-my-cards-20-public-experiment","image":"https://trello-attachments.s3.amazonaws.com/5bc0fa6a7357e471f8cbda46/5bd24be4e31356371cb9d421/670135dc84b895af46531c73c881be68/superHomeTeamCards.png"},"audiences":["allMembers"],"experimentVersion":"v1","experimentAllocation":{"allMembers":1},"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/superHomeTeamCards.json
// module id = XB8T
// module chunks = 12